import React, { useImperativeHandle, useState } from "react";
import { Input, Button } from "antd";
import "antd/dist/antd.css";
import { getDatabase, getStoreList } from "../../Table";
import { Pagination } from "../PageNav";
import "./Search.css";
import "../PageNav/Pages.css";
import { CloseOutlined } from "@ant-design/icons";
import { Filter } from "../Filter/Filter";
import useForceUpdate from "use-force-update";
var storeNames = getStoreList(),
  listLength = storeNames.length,
  db = getDatabase(),
  searchCaption = "";

export const Search = () => {
  const [userInput, updateUserInput] = useState("");
  var results = () => {
    var selectedRows = [];
    searchCaption = "Searched For: " + "'" + userInput + "'";
      
    for (var i = 0; i < listLength; i++) {
      if (contains(userInput, storeNames[i]) === true) {
        selectedRows.push(i);
      }
    }

      var searchResults = [];
      if (selectedRows.length > 0) {
          searchResults.push(db[0]);
      }
     
    for (var k = 0; k < selectedRows.length; k++) {
      searchResults.push(db[selectedRows[k]]);
      
      }
      if (searchResults.length == 0)
      {
          searchResults.push("No Results");
      }
      return searchResults;
  };
  function SearchBox() {
    return (
      <Input.Search
        style={{ width: "54%" }}
        className="searchField"
        id="searchField"
        // onSearch={() =>
        //   updateUserInput(document.getElementById("searchField").value)
        // }
        onSearch={(newVal) => updateUserInput(newVal)}
        placeholder="Search for a store :) "
      />
    );
  }
   
  return (
    <div id="searchBoxContainer">
      <SearchBox />
      <div id="PaginationContainer">
        {userInput === "" ? (
          <Pagination  />
              ) : userInput === "false" ? null : (
                      <span>
                          <div id="pageNav">
                              <button
                                  id="Button1"
                                  className="pageNav"
                                  disabled
                                  color="#96baff"
                              >
                                  1
                              </button>
                              <button
                                  id="Button2"
                                  className="pageNav"
                                  color="#96baff"
                                  disabled
                              >
                                  2
                              </button>
                              <button
                                  id="Button3"
                                  className="pageNav"
                                  color="#96baff"
                                  disabled
                              >
                                  3
                                </button>
                              <button
                                  id="Button4"
                                  className="pageNav"
                                  color="#96baff"
                                  disabled
                              >
                                  4
        </button>
                              <button
                                  id="Button5"
                                  className="pageNav "
                                  color="#96baff"
                                  disabled
                              >
                                  5
        </button>

                          </div>
                      <div id="shopifyData">
                        {results()}
                      </div>
                      </span>  
        )}
      </div>
      <div>
        {userInput === "" ? null : (
          <div id="currentSearch">
            <p id="searchCaption">{searchCaption}</p>
            <Button
              onClick={() => updateUserInput("")}
              size="small"
              id="cancel"
            >
              <CloseOutlined id="endSearch" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

function contains(s1, s2) {
  var contains = false;
  for (var i = 0; i < s2.length; i++) {
    for (var j = i + 1; j < s2.length + 1; j++) {
      if (s1.toLowerCase() === s2.toLowerCase().slice(i, j)) {
        contains = true;
      }
    }
  }
  return contains;
}
